export const ANALYST_ROUTES = {
  DASHBOARD: '/assessments/dashboard',
  ASSESSMENTS: '/assessments/all',
  ASSESSMENTS_GROUP: '/assessments/group-analysis',
  ASSESSMENTS_VIEW: '/assessments/:id/results',
  PEOPLE: '/assessments/people',
  COMPANIES: '/assessments/companies',
  COMPANIES_VIEW: '/assessments/companies/:companyId',
  GROUPS: '/assessments/groups',
  GROUPS_VIEW: '/assessments/groups/:listId',
  PROFILE: '/assessments/account',
  LEADS: '/assessments/leads',
  LEADS_VIEW: '/assessments/leads/:leadId',
  CAMPAIGN_LINKS: '/assessments/campaign-links',

  UNIVERSITY: '/university/dashboard',
  UNIVERSITY_COURSES: '/university/courses',
  UNIVERSITY_CERTIFICATES: '/university/certificates',
  UNIVERSITY_COURSES_VIEW: '/university/courses/:courseId',
  UNIVERSITY_COURSES_CONTENT: '/university/courses/:courseId/content/:contentId',
  UNIVERSITY_COURSES_ENROLL: '/university/courses/:courseId/enroll',
  UNIVERSITY_COURSES_UNENROLL: '/university/courses/:courseId/unenroll',
  STUDENT_DASHBOARD: '/dashboard',

  // Fallback
  NOT_FOUND: '*',
} as const;